(function () {
  'use strict';

  function normalize(text) {
    return (text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function applyBadgeClass(label, text) {
    var rules = [
      { names: ['estate', 'summer', 'estivo'], className: 'ProductItem__Label--estate' },
      { names: ['best seller', 'bestseller'], className: 'ProductItem__Label--best-seller' },
      { names: ['novita', 'nuovo', 'new'], className: 'ProductItem__Label--novita' },
      { names: ['piu venduto', 'piu venduti', 'top seller'], className: 'ProductItem__Label--piu-venduto' },
      { names: ['luxury', 'lusso'], className: 'ProductItem__Label--luxury' },
      { names: ['fresh', 'fresco'], className: 'ProductItem__Label--fresh' },
      { names: ['evening', 'sera', 'serale'], className: 'ProductItem__Label--evening' },
      { names: ['donna', 'femminile'], className: 'ProductItem__Label--donna' },
      { names: ['uomo', 'maschile'], className: 'ProductItem__Label--uomo' },
      { names: ['unisex'], className: 'ProductItem__Label--unisex' }
    ];

    label.classList.add('ProductItem__Label--custom');

    rules.some(function (rule) {
      var matches = rule.names.some(function (name) {
        return text === name || text.indexOf(name) !== -1;
      });

      if (matches) label.classList.add(rule.className);
      return matches;
    });
  }

  function cleanBadges(root) {
    var scope = root || document;

    scope.querySelectorAll('.ProductItem__Label').forEach(function (label) {
      if (label.classList.contains('ProductItem__Label--onSale') || label.classList.contains('ProductItem__Label--soldOut')) {
        return;
      }

      var text = normalize(label.textContent);

      if (text === 'in vendita' || text === 'vendita' || text.indexOf('in vendita') !== -1) {
        label.remove();
        return;
      }

      applyBadgeClass(label, text);
    });

    scope.querySelectorAll('.ProductItem__LabelList').forEach(function (list) {
      if (!list.querySelector('.ProductItem__Label')) list.remove();
    });
  }

  function start() {
    cleanBadges(document);

    if (!window.MutationObserver || !document.body) return;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) cleanBadges(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
